"use client";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, AppState } from "@/store/configureStore";
import { NewPasswordProps } from "@/interface/authentication";
import { RESET_PASSWORD_API } from "@/constants";
import { clearIdentifier } from "@/store/slices/identifier";
import toast from "react-hot-toast";

type Props = {
	setIsNewPassword: React.Dispatch<
		React.SetStateAction<"default" | "success" | "error">
	>;
};

const useNewPassword = ({ setIsNewPassword }: Props) => {
	const user = useSelector((state: AppState) => state.user);
	const dispatch = useDispatch<AppDispatch>();
	const identifier = useSelector((state: AppState) => state.identifier);

	const schema = yup.object({
		password: yup.string().required("Password is required"),
		confirm_password: yup
			.string()
			.required("Confirm your password")
			.oneOf([yup.ref("password")], "Passwords must match"),
	});

	const {
		register,
		handleSubmit,
		formState: { errors, isSubmitting },
	} = useForm({
		resolver: yupResolver(schema),
	});

	const submitForm = async (data: NewPasswordProps) => {
		try {
			const response = await axios.put(RESET_PASSWORD_API, {
				identifier: identifier?.identifier,
				newPassword: data.confirm_password,
			});
			// console.log("API Response", response.data);
			setIsNewPassword("success");
			toast.success(response?.data?.msg);
			dispatch(clearIdentifier());
		} catch (error: string | any) {
			// console.log("API Error", error);
			setIsNewPassword("error");
		}
	};

	return {
		register,
		handleSubmit,
		errors,
		submitForm,
		isSubmitting,
	};
};

export default useNewPassword;
